const zh_hant = {
  recharge_center: "訂閱中心",
  experience_membership: "體驗會員",
  remaining_time: "體驗時間剩餘",
  currently_using: "當前使用",
  free_open: "免費開戶",
  buy_now: "立即訂閱",
  Search_for_quotation: "査詢報價",
  join_in: "立即使您的教學更加互動、有趣和投入",
  find_plan: "尋找適合您的計劃",
  free: "免費試用",
  subscribe: "訂閱",
  recharge_successful: "訂閱成功",
  recharge_fail: "訂閱失敗",
  recharge_cancel: "用戶取消訂閱",
  pending_payment: "待付款",
  refunded: "已退款",
  currently_have: "當前已訂閱",
  renew: "是否更新訂閱",
  expired: "已過期",
  duration: "VIP時間",
  status: "VIP狀態",
  "non-member": "現在還不是會員",
  recharge: "訂閱",
  free_trial: "免費試用",
  per_year_license: "每個使用名額年繳",
  free_7_day_text: "立即解鎖Idea Lab <b>30天免費體驗</b>，到期後升級訂閱即可持續使用。",
  not_available: "此功能尚未開放",
  redemptionCode: "使用兌換碼",
  redemption: "使用",
  useSuccess: "使用成功",
  useRedemptionCode: "兌換",
  per: "每用戶",
  perYear: "每月",
  day: "天",
  signUpNow: "立即註冊",
  expiredSoon: "您的訂閱即將到期,請及時續訂以便繼續使用 Idea Lab 的完整功能。",
  beforeExpiredTips: "您的體驗期即將結束，升級訂閱即可解鎖 Idea Lab 的完整功能。",
  contact_us: "聯繫我們",
  email: "電子郵件",
  phone: "電話",
  whatsapp: "WhatsApp",
  website: "公司網站",
  confirm: "確認",
  per_month: "每月費用"
};
const zh_cn = {
  recharge_center: "订阅中心",
  experience_membership: "体验会员",
  remaining_time: "体验时间剩余",
  currently_using: "当前使用",
  free_open: "免费开户",
  buy_now: "立即订阅",
  Search_for_quotation: "查询报价",
  join_in: "立即让您的教学更加互动、有趣和投入",
  find_plan: "寻找适合您的计划",
  free: "免费试用",
  subscribe: "订阅",
  recharge_successful: "订阅成功",
  recharge_fail: "订阅失败",
  recharge_cancel: "用户取消订阅",
  pending_payment: "待付款",
  refunded: "已退款",
  currently_have: "当前已订阅",
  renew: "是否更新订阅",
  expired: "已过期",
  duration: "VIP时间",
  status: "VIP状态",
  "non-member": "现在还不是会员",
  recharge: "订阅",
  free_trial: "免费试用",
  per_year_license: "每个使用名额年缴",
  free_7_day_text: "立即解锁Idea Lab <b>30天免费体验</b>，到期后升级订阅即可持续使用。",
  not_available: "此功能尚未开放",
  redemptionCode: "使用兑换码",
  redemption: "使用",
  useSuccess: "使用成功",
  useRedemptionCode: "兑换",
  per: "每用户",
  perYear: "每月",
  day: "天",
  signUpNow: "立即注册",
  expiredSoon: "您的订阅即将到期,请及时续订以便继续使用 Idea Lab 的完整功能。",
  beforeExpiredTips: "您的体验期即将结束，升级订阅即可解锁 Idea Lab 的完整功能。",
  contact_us: "联系我们",
  email: "电子邮件",
  phone: "电话",
  whatsapp: "WhatsApp",
  website: "公司网站",
  confirm: "确认",
  per_month: "每月费用"
};
const en = {
  recharge_center: "Subscription Center",
  experience_membership: "Trial Member",
  remaining_time: "Period Ends In",
  currently_using: "Currently using",
  free_open: "Free account opening",
  buy_now: "Subscribe Now",
  Search_for_quotation: "Request Quote",
  join_in: "Make your teaching more interactive, fun and engaging",
  find_plan: "Find the right plan for you",
  day: "days",
  subscribe: "Subscription",
  recharge_successful: "Recharge successful",
  recharge_fail: "Recharge failed",
  recharge_cancel: "Termination of payment",
  pending_payment: "Pending payment",
  refunded: "Refunded",
  currently_have: "You currently have ",
  renew: "do you want to renew the subscription",
  expired: "Expired",
  duration: "VIP duration",
  status: "VIP status",
  "non-member": "Currently a non-member",
  recharge: "Recharge",
  free_trial: "Free Trial",
  per_year_license: " (1 license) billed annually ",
  not_available: "This feature is not yet available",
  redemptionCode: "Use redemption",
  useRedemptionCode: "Exchange",
  redemption: "Exchange",
  useSuccess: "Success",
  per: "per host",
  free: "Free Trial",
  signUpNow: "Sign up now",
  perYear: "per month",
  expiredSoon:
    "Your subscription is about to expire, please renew in time to continue to experience Idea lab.",
  free_7_day_text:
    "Your <b>30-day free trial</b> of Idea Lab is now active.Upgrade to continue after expiration.",
  beforeExpiredTips: "Your trial has ended, Upgrade now to unlock function.",
  contact_us: "Contact Us",
  email: "Email",
  phone: "Phone",
  whatsapp: "WhatsApp",
  website: "Website",
  confirm: "Confirm",
  per_month: "per host per month"
};

const es = {
  recharge_center: "Suscripción",
  experience_membership: "Membresía de prueba",
  remaining_time: "El período termina en",
  currently_using: "Actualmente usando",
  free_open: "Registro gratuito",
  buy_now: "Suscribirse ahora",
  Search_for_quotation: "Consulta y cotización",
  join_in: "Hacer que su enseñanza sea más interactiva, divertida e inmersiva de inmediato",
  find_plan: "Buscando un plan adecuado para usted",
  free: "Prueba gratuita",
  subscribe: "Suscripción",
  recharge_successful: "Suscripción exitosa",
  recharge_fail: "Fallo en la suscripción",
  recharge_cancel: "Terminación de pago",
  pending_payment: "Pago pendiente",
  refunded: "Reembolsado",
  currently_have: "Actualmente tienes",
  renew: "¿Quieres renovar la suscripción?",
  expired: "Expirado",
  duration: "Duración del VIP",
  status: "Estado VIP",
  "non-member": "Actualmente no eres miembro",
  recharge: "Suscripción",
  free_trial: "Prueba gratuita",
  per_year_license: "(1 licencia) facturada anualmente",
  free_7_day_text:
    "Tu <b>prueba gratuita de 30 días</b> de Idea Lab está activa ahora. Actualiza para continuar después de la expiración.",
  not_available: "Esta función aún no está disponible",
  redemptionCode: "Usar canje",
  redemption: "Aplicar",
  useSuccess: "Éxito",
  useRedemptionCode: "Aplicar",
  per: "por host",
  perYear: "por mes",
  day: "días",
  signUpNow: "Regístrate ahora",
  expiredSoon:
    "Tu suscripción está a punto de expirar, por favor renueva para continuar experimentando Idea Lab.",
  beforeExpiredTips:
    "Tu suscripción está a punto de expirar, por favor renueva para continuar experimentando Idea Lab.",
  contact_us: "Contáctanos",
  email: "Correo electrónico",
  phone: "Teléfono",
  whatsapp: "WhatsApp",
  website: "Sitio web",
  confirm: "Confirmación",
  per_month: "Gastos mensuales"
};
export default { zh_hant, en, es, zh_cn };
